var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanFilters = function SvgCleanFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "currentColor",
    viewBox: "0 0 13 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8072 0.342773L12.2345 9.77077L11.2919 10.7134L8.7432 8.16544L8.18787 8.99944V14.6661H4.18787V8.99944L0.854533 3.99944H0.187866V2.66611H3.24453L1.86453 1.28544L2.8072 0.342773ZM4.57787 3.99944H2.4572L5.5212 8.59544V13.3328H6.85453V8.59544L7.78253 7.20411L4.57787 3.99944ZM12.1879 2.66611V3.99944H11.5212L10.2445 5.91411L9.2832 4.95211L9.91853 3.99944H8.32987L6.99653 2.66611H12.1879Z"
  })));
};
export default SvgCleanFilters;